/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";

export const LastNameFormatter = (cellContent, row, rowIndex) => {
  const { lastname } = row;
  return (
    <>
      <div className="d-flex align-items-center text-capitalize">
        {lastname ? lastname : "-"}
      </div>
      <> </>
    </>
  );
};
